module.exports = __webpack_public_path__ + "media/images/dashboard/hat-3b5356454806c63d135fd90619bef2db.svg";